import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/hubspot-customer-mobile.css";
import "./styles/customer-mobile.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Helmet } from "react-helmet";
import { registerStaleBuildListeners } from "./utils/staleBuildRecovery";

// Render ağacı dışında (import(), script onerror) patlayan bayat bundle
// hatalarını da yakala; aksi halde kullanıcı boş sayfada kalıyor.
registerStaleBuildListeners();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <Helmet>
      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-eu1.hs-scripts.com/25978262.js"
      ></script>
    </Helmet>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
